// src/components/auth/AdminRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user exists and has admin privileges
  if (!user || (!user.permissions?.isAdmin && !user.permissions?.isDomainAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
